import { TruncatedTextWithTooltip } from '@/ui/TooltipText';
import { Avatar, Flex, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useDateFormat } from '@/hooks/useDateFormat';
import { useIsMobile } from '@/hooks/use-IsMobile';

export const AssessmentInfo = ({ assessment = {}, application, candidate }) => {
  const { dateFormat, timeFormat } = useDateFormat();
  const isMobile = useIsMobile();

  const contactName = application?.contact?.name || candidate?.name;
  const contactAvatarUrl =
    application?.contact?.avatar_url || candidate?.avatar;
  const isInternalPlatform = assessment.platform === 'internal';

  return (
    <Flex
      p="12px 22px"
      bg="ats-tertiary"
      borderRadius="sm"
      gap="12px"
      flexDir={isMobile ? 'column' : 'row'}
    >
      <Flex
        flexDir="column"
        gap="6px"
        w={isMobile ? '100%' : '30%'}
        maxW={isMobile ? '100%' : '30%'}
      >
        <Text size="sm-medium" color="secondary-900">
          Candidate
        </Text>
        <Flex gap="6px" alignItems="center">
          <Avatar
            name={contactName}
            src={contactAvatarUrl}
            className="avatar-xs"
            width="16px"
            height="16px"
            borderRadius="xs"
          />
          <TruncatedTextWithTooltip
            enableTooltip={true}
            size="sm-medium"
            text={contactName}
          />
        </Flex>
      </Flex>
      <Flex
        flexDir="column"
        gap="6px"
        w={isMobile ? '100%' : '30%'}
        maxW={isMobile ? '100%' : '30%'}
      >
        <Text size="sm-medium" color="secondary-900">
          Assessment sent
        </Text>
        <TruncatedTextWithTooltip
          enableTooltip={true}
          size="sm-medium"
          text={dayjs(
            isInternalPlatform ? assessment.sent_at : assessment.invited_at
          ).format(`${dateFormat.label}, ${timeFormat}`)}
        />
      </Flex>
      <Flex
        flexDir="column"
        gap="6px"
        w={isMobile ? '100%' : '30%'}
        maxW={isMobile ? '100%' : '30%'}
      >
        <Text size="sm-medium" color="secondary-900">
          Assessment submitted
        </Text>
        <TruncatedTextWithTooltip
          enableTooltip={true}
          size="sm-medium"
          text={dayjs(assessment.submitted_at).format(
            `${dateFormat.label}, ${timeFormat}`
          )}
        />
      </Flex>
    </Flex>
  );
};
